<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('tel1')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('tel77')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="searchright">
                        <el-button size="small" type="primary" @click="openadd">+{{$t('tel80')}}</el-button>
                    </div>
                    <div class="top"></div>
                    <el-table :data="list" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="timeDay" :label="$t('tel7')"></el-table-column>
                        <el-table-column prop="maxNumber" :label="$t('tel78')"></el-table-column>
                        <el-table-column prop="stayDay" :label="$t('tel79')"></el-table-column>
                        <el-table-column prop="nameType" :label="$t('type')"></el-table-column>
                        <el-table-column prop="groupName" :label="$t('groupName')"></el-table-column>
                        <el-table-column prop="jobName" :label="$t('operator')" width="150">
                            <template slot-scope="scope">
                                <el-button size="small" @click="openedit(scope.row)" type="primary" icon="el-icon-edit"
                                    circle plain style="margin-right:5px;"></el-button>
                                <el-popconfirm :title="$t('isDel')" @confirm="deleteproduct(scope.row)">
                                    <el-button size="small" type="warning" icon="el-icon-delete-solid" circle slot="reference" plain></el-button>
                                </el-popconfirm>
                                <el-popconfirm title="确定需要重新分配吗？" @confirm="allocation(scope.row)" style="margin-left:5px;">
                                    <el-button size="small" type="info" icon="el-icon-s-help" circle slot="reference" plain></el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
            </div>
        </div>
        <pop-up :title="status == 1? $t('tel80') : $t('tel81') " :isshow="showadd" :haveconfirm="true" @close="getclose" @confirm="getconfirm">
            <div slot="box">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small">
                    <el-form-item :label="$t('tel7')" prop="timeDay">
                        <el-date-picker
                            v-model="value1"
                            type="date"
                            :placeholder="$t('xzTime')"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('tel78')" prop="maxNumber">
                        <el-input-number v-model="form.maxNumber"/>
                    </el-form-item>
                    <el-form-item :label="$t('tel79')" prop="stayDay">
                        <el-input-number v-model="form.stayDay"/>
                    </el-form-item>
                    <el-form-item :label="$t('type')" prop="stayDay">
                        <el-input v-model="form.nameType"/>
                    </el-form-item>
                    <el-form-item :label="$t('tel82')" >
                        <el-select v-model="form.groupId" :placeholder="$t('qxzfz')">
                            <el-option v-for="item in grouplist" :key="item.id" :label="item.groupName" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    maxNumber: null,
                    timeDay: null,
                    stayDay: null,
                    nameType: null,
                    groupId: null,
                },
                defaultProps: {
                    label: "name",
                    isLeaf: 'isLeaf'
                },
                total: 1,
                pageNo: 1,
                pageSize: 10,
                loading: false,
                showadd: false,
                list: [],
                grouplist:[],
                value1:'',
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getgrouplist()
            this.getList()
        },
        methods: {
            getgrouplist(){
                _api.get(apiurl.telGroup1, {
                }).then(res => {
                    this.grouplist = res.data
                })
            },
            openadd() {
                this.showadd = true
                this.status = 1
                this.form = {
                    id: null,
                    maxNumber: null,
                    timeDay: null,
                    stayDay: null,
                    nameType: null,
                    groupId: null,
                }
            },
            openedit(row) {
                this.status = 2
                this.form.id = row.id
                this.form.maxNumber = row.maxNumber
                this.form.timeDay = row.timeDay
                this.form.stayDay = row.stayDay
                this.form.nameType = row.nameType
                this.form.groupId = row.groupId
                this.value1 = row.timeDay
                this.showadd = true
            },
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            handleNodeClick(mydata, node, obj) {
                this.loading = true
                this.getList()
            },
            deleteproduct(row) {
                _api.delete(apiurl.allconfig, row.id).then(res => {
                    this.$notify({
                        title: this.$t('success'),
                        message: this.$t('delSuccess'),
                        type: 'success'
                    });
                    this.pageNo = 1
                    this.getList()

                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    });
                })
            },
            allocation(row) {
                _api.get(apiurl.allocation, {
                    id: row.id
                }).then(res => {
                    this.$notify({
                        title: this.$t('success'),
                        message: this.$t('delSuccess'),
                        type: 'success'
                    });
                    this.pageNo = 1
                    this.getList()

                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    });
                })
            },
            getconfirm() {
                this.form.timeDay = this.value1
                if (this.status == 1) { //如果是添加
                    _api.post(apiurl.allconfig, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('addSuccess')
                        })
                        this.pageNo = 1
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            maxNumber: null,
                            timeDay: null,
                            stayDay: null,
                            nameType: null,
                            groupId: null,
                        }
                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                } else { //如果是编辑
                    _api.put(apiurl.allconfig, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('editSuccess')
                        })
                        this.pageNo = 1
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            maxNumber: null,
                            timeDay: null,
                            stayDay: null,
                            nameType: null,
                            groupId: null,
                        }
                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                }
                  
            },
            getList() {
                this.loading = true
                _api.get(apiurl.allconfig, {
                    page: this.pageNo,
                    size: this.pageSize,
                }).then(res => {
                    this.loading = false
                    this.list = res.data.list
                    this.total = res.data.total
                })
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                console.log(data)
                this.pageNo = data
                this.getList()
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>